import {
  createSlice,
  PayloadAction,
  // createAsyncThunk,
  // createDraftSafeSelector,
} from "@reduxjs/toolkit";
import { getUserInfo } from "store/reducers/user";
import store, { RootState } from "store";

interface IInitialState {
  taskModalItem: {
    visible: boolean
  }
}

const initialState: IInitialState = {
  taskModalItem: {
    // 待办事项弹窗，是否展示
    visible: false
  }
};

export const taskSlice = createSlice({
  name: "task",
  initialState: initialState,
  reducers: {
    setTaskModalItem: (state, action: PayloadAction<any>) => {
      state.taskModalItem = Object.assign({}, state.taskModalItem, action.payload);
    }
  },
});

export const mapTaskModalItem = (state: RootState) => state.task.taskModalItem;
export const { setTaskModalItem } = taskSlice.actions;

// 设置待办事项弹窗
export const setTaskModalVisible = (visible: boolean) => {
  const dispatch = store.dispatch;

  dispatch(setTaskModalItem({
    visible: visible
  }))
  // 关闭弹窗，重新获取用户详情
  if (!visible) {
    dispatch(getUserInfo({}));
  }
};

export default taskSlice.reducer;
